import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Spinner } from 'react-bootstrap';

import { useHttpUtils } from '../../../Utilities/useHttpUtils';
import useAlert from '../../../Alerts/useAlert';
import { LotDetailContext } from '../../../Contexts/LotDetailContext';

function ExportProcessDataButton() {

    const { t } = useTranslation();
    const { setAlert } = useAlert();
    const { fetchBlobAuthenticated, downloadFile } = useHttpUtils();

    const {
        lotDetail: {
            summary: {
                lotNumber,
                lotRevisionId
            }
        },
        lotFlags: {
            canExportProcessData
        }
    } = useContext(LotDetailContext);

    const [loading, setLoading] = useState<boolean>(false);

    const exportProcessData = async () => {
        setLoading(true);

        let url = `api/v1/lot/${lotNumber}/processData`;
        if (lotRevisionId) {
            url += `?revisionId=${lotRevisionId}`;
        }

        await fetchBlobAuthenticated(url)
            .then(async response => {
                if (response.ok) {
                    return response.blob();
                } else {
                    throw new Error(await response.text());
                }
            })
            .then((response) => {
                return response = response.slice(0, response.size, "application/csv");
            })
            .then(blob => {
                downloadFile(blob, `ProcessData-${lotNumber}.csv`);
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
            })
            .finally(() => {
                setLoading(false);
            })
    };

    return (
        <Button variant="primary"
            disabled={loading}
            hidden={!canExportProcessData}
            onClick={() => exportProcessData()}>
            {t('LotDetails.Summary.ExportOneMin')}
            {loading &&
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="ms-2"
                />
            }
        </Button>
    );
}

export default ExportProcessDataButton;